import React, { FunctionComponent, useMemo } from 'react';
import LinkRenderer from './renderers/link/LinkRenderer';
import ListRenderer from './renderers/list/ListRenderer';
import ListItemRenderer from './renderers/list-item/ListItemRenderer';
import ParagraphRenderer from './renderers/paragraph/ParagraphRenderer';
import Markdown, { MarkdownProps } from '../markdown/Markdown';
import * as styles from './ArticleMarkdown.style';

export const MARKDOWN_DISALLOWED_ELEMENTS = [
  'blockquote',
  'del',
  'img',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'pre',
  'code',
  'html',
];

export const ArticleMarkdown: FunctionComponent<MarkdownProps> = ({
  children,
  components = {},
}) => {
  const mergedRenderers = useMemo(() => ({
    ul: ListRenderer,
    ol: ListRenderer,
    li: ListItemRenderer,
    p: ParagraphRenderer,
    ...components,
    a: LinkRenderer,
  }), [components]);

  return (
    <Markdown
      css={styles.content}
      disallowedElements={MARKDOWN_DISALLOWED_ELEMENTS}
      components={mergedRenderers}
    >
      {children}
    </Markdown>
  );
};

export default ArticleMarkdown;
